import Button from '@vfuk/core-button';
import { InteractionEvent } from '@vfuk/core-interaction/dist/Interaction.types';
import Paragraph from '@vfuk/core-paragraph';
import TopNavigation from '@vfuk/core-top-navigation';
import { withPrefix } from 'gatsby';
import { useState } from 'react';

import { useModalContext } from '@/hooks/modal/useModal';
import { useSWTopNavigation } from '@/hooks/useSWTopNavigation';
import { clearUserSession, useAppDispatch, useAppSelector } from '@/store';

import { TopNavigationWrapper, UserNameWrapper } from './SWTopNavigation.styles';

const SWTopNavigation = () => {
  const { id, topNav, primaryNav, logoNav, secondaryNav } = useSWTopNavigation();
  const dispatch = useAppDispatch();
  const userBasket = useAppSelector(state => state.userBasket.data);
  const { user } = useAppSelector(state => state.userSession);
  const { toggleModal } = useModalContext();
  const [showButton, setShowButton] = useState<boolean>(false);

  const handleSignOut = (event: InteractionEvent) => {
    event.preventDefault();
    dispatch(clearUserSession());
    setShowButton(false);
  };

  const launchLogin = () => {
    toggleModal(true, 'Login');
  };

  const showSignOut = () => {
    setShowButton(true);
    setTimeout(() => setShowButton(false), 5000);
  };

  return (
    id && (
      <TopNavigationWrapper>
        <TopNavigation
          {...(topNav && {
            topNav: {
              ...topNav,
              leftLinks: topNav.leftLinks?.map(link => ({
                ...link,
                ...(link.href && { href: withPrefix(link.href) }),
              })),
            },
          })}
          primaryNav={{
            ...primaryNav,
            links: primaryNav?.links.map(link => ({
              ...link,
              ...(link.href && { href: withPrefix(link.href) }),
              links: link.links?.map(eachLink => ({
                ...eachLink,
                ...(eachLink.href && { href: withPrefix(eachLink.href) }),
              })),
            })),
          }}
          logo={{
            ...logoNav,
            ...(logoNav?.href && { href: withPrefix(logoNav?.href) }),
          }}
          {...(secondaryNav && {
            secondaryNav: {
              ...secondaryNav,
              iconNavLinks: user
                ? [
                    {
                      id: 'your-basket',
                      text: 'Your Basket',
                      href: withPrefix('/marketplace/product-list/basket'),
                      icon: 'shopping-trolley',
                      numberBadge: userBasket.items.length || 0,
                    },
                    {
                      id: 'signed-in',
                      text: 'Signed In',
                      href: '',
                      icon: 'signed-in',
                      ...{ onClick: () => showSignOut() },
                    },
                  ]
                : [
                    {
                      id: 'sign-out',
                      text: 'Sign Out',
                      href: '',
                      icon: 'admin',
                      ...{ onClick: () => launchLogin() },
                    },
                  ],
            },
          })}
          mobileNavTrigger={{
            id: `${id}-mobile-nav-trigger`,
            text: 'Menu',
          }}
          sideNavigationCloseButton={{
            id: `${id}-close-button`,
            srText: 'Close side navigation',
          }}
          skipLink={{
            text: `${id}-Skip to main content`,
            skipLinkId: '#main',
          }}
        />
        <UserNameWrapper>
          {user !== undefined && (
            <>
              <Paragraph justify="right" size={2}>
                {user?.selectedAccount?.customerAccountName}
              </Paragraph>
              {showButton && (
                <Button
                  {...(topNav?.srText && {
                    htmlAttributes: {
                      dataAttributes: {
                        'data-selector': 'Sign Out Button',
                      },
                    },
                  })}
                  text="Sign Out"
                  appearance="secondary"
                  inverse
                  onClick={handleSignOut}
                  width="auto"
                />
              )}
            </>
          )}
        </UserNameWrapper>
      </TopNavigationWrapper>
    )
  );
};

export default SWTopNavigation;
